// extracted by mini-css-extract-plugin
export var headerHolder = "Header-module--headerHolder--bfc78";